import { useEffect, useState } from "react";
import { fetchStaffRoles, StaffRole } from "../api/contentful";

export function useStaffRoles() {
  const [data, setData] = useState<StaffRole[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchStaffRoles()
      .then((res) => setData(res))
      .catch((err) => setError(err.message || "Failed to load staff roles"))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
